<div id="managePopUp">
  <div class="modal-header justify-content-start">
    <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" *ngIf="!isConfirmationPopup" class="m-r-15 successIcon"
      alt="Success">
    <h4 class="modal-title mt-0 p-b-20" id="modal-basic-title">{{header}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeSuccessPopup()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <!-- success popup start  -->
  <div class="modal-body" *ngIf="!isConfirmationPopup">
    <div class="row" *ngIf="orderStatus">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <p class="mb-2 ">{{authoringContentData?.changeNumberAuthoring?.newNumberTxt}}</p>
        <p id="new-number">{{orderStatus?.newMsisdn | NpaNpxPipe:true}}</p>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <p class="mb-2">{{authoringContentData?.changeNumberAuthoring?.transactionNumberTxt}}</p>
        <p id="singleline-conf-txnno">{{orderStatus?.orderId}}</p>
      </div>
    </div>
    <div class="row" *ngIf="bulkOrderStatus">
      <div class="col-12">

        <p class="m-b-15" *ngIf="bulkUploadFlow">
          {{authoringContentData?.changeNumberAuthoring?.bulkConfirmationText}}</p>
        <span *ngIf="bulkUploadFlow" class="lead block m-b-20 p-b-10">{{bulkOrderStatus?.token}}</span>
      </div>
    </div>
    <div class="row" *ngIf="isPortIn">
      <div class="col-12">
        <p class="portInSuccessTransaction m-b-20" [innerHTML]='portInSuccessTransaction'></p>
      </div>
    </div>
    <p class="m-b-20 single-line-resu" *ngIf="modalBodyContent" [innerHTML]='modalBodyContent'></p>

    <p class="m-b-20 single-line-resu" *ngIf="token && flowType === 'strategic-port-in'">{{authoringContentData?.manageLine?.transaction}} <span
        class="transID-port-in" id="old-number">{{token}}</span></p>
    <p class="m-b-20 single-line-resu" *ngIf="token && flowType !== 'strategic-port-in'">{{authoringContentData?.manageLine?.transactionNo}} <span
          id="old-number">{{token}}</span></p>  
    <p class="m-b-20 single-line-resu" *ngIf="isChangeNumber">
      {{authoringContentData?.changeNumberAuthoring?.confirmationMsgTxt}}</p>
    <div class=" pb-0 pt-0 pl-sm-15 row" *ngIf="bulkUploadFlow && flowType !== 'strategic-port-in'">
      <div class="col-12">
        <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" class="m-r-10" (click)="downloadSpreadsheet()"
          alt="Download the line details for the successfull items">
        <a href="javascript:void(0)" id="download-suspend-file" (click)="downloadSpreadsheet()"
          class="upload-file-link">
          {{authoringContentData?.manageLine?.downloadSuccessItems}}
        </a>
      </div>
    </div>
    <div class=" pb-0 pt-0 pl-sm-15 row" *ngIf="bulkUploadFlow && flowType === 'strategic-port-in'">
      <div class="col-12">
          <p [innerHTML]="portInSuccessBody"></p>
          <p>{{authoringContentData?.manageLine?.portInSuccessText}}</p>
      </div>
    </div>
    <div class=" pb-0 pt-0 pl-sm-15 row" *ngIf="multiLineFlow">
      <div class="col-12">
        <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" class="m-r-10" (click)="downloadTransferNumberMultiLineData()"
          alt="Download the line details for the successfull items">
        <a href="javascript:void(0)" id="download-suspend-file" (click)="downloadTransferNumberMultiLineData()"
          class="upload-file-link">
          {{authoringContentData?.manageLine?.downloadSuccessItems}}
        </a>
      </div>
    </div>
  </div>
  <!-- success popup end -->

  <!-- confirmation popup start-->
  <div class="modal-body" *ngIf="isConfirmationPopup">
    <p class="processed-text" [innerHTML]="processText"></p>
    <div *ngIf="isChangeNumber || isPortIn">
      <div class="row" *ngIf="orderStatus">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <p class="mb-2 ">{{authoringContentData?.changeNumberAuthoring?.newNumberTxt}}</p>
          <p id="new-number">{{orderStatus?.newMsisdn | NpaNpxPipe:true}}</p>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <p class="mb-2">{{authoringContentData?.changeNumberAuthoring?.transactionNumberTxt}}</p>
          <p id="singleline-conf-txnno">{{isPortIn ? orderStatus?.accountTransactionReferenceNumber : orderStatus?.orderId}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="isRestore">
        <p>{{authoringContentData?.manageLine?.transactionNumberText}}</p>
        <p id="old-number" class="f-18"><strong>{{token}}</strong></p>
    </div>
    <div *ngIf="isSimChange" class="row">
      <div class="col-sm-6">
        <p>{{eSimEnabled && newSimNumber.length == eidLength ? authoringContentData?.manageLine?.deviceEidTxt : authoringContentData?.manageLine?.newSimNmbrTxt}}</p>
        <p id="old-number" class="f-18"><strong>{{newSimNumber}}</strong></p>
      </div>
      <div class="col-sm-6">
        <p>{{authoringContentData?.manageLine?.transactionNumberText}}</p>
        <p id="old-number" class="f-18"><strong>{{token}}</strong></p>
      </div>
    </div>
    <div *ngIf="isSuspend">
      <p class="user-email">{{orderStatus}}</p>
    </div>
    <div *ngIf="isCancelSubscriber || isChangeService">
      <div class="col-12">
        <p class="m-b-20 single-line-resu" *ngIf="token">{{authoringContentData?.manageLine?.transactionNo}} <span
          id="old-number">{{token}}</span></p>
      </div>
    </div>
    <p class="m-b-20 single-line-resu" *ngIf="modalBodyContent"  [innerHTML]='modalBodyContent'></p>
  </div>
  <!-- confirmation popup end -->
</div>
